<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-title class="mb-1">
          Satış Detayları
        </b-card-title>
        <b-card-sub-title />
      </div>
      <!--/ title and subtitle -->

      <!-- badge -->
      <div class="d-flex align-items-center flex-wrap mt-sm-0 mt-1">
        <h5 class="font-weight-bolder mb-0 mr-1" />

      </div>
      <!--/ badge -->
    </b-card-header>

    <b-card-body>
      <b-button
        variant="primary"
        size="sm"
        class="mb-2"
        @click="toExcel"
      >
        <feather-icon
          icon="FileTextIcon"
          class="mr-50"
        />
        <span class="text-nowrap">{{ targetYear }} {{ $t('Yılına ait olanları excel olarak indir') }}</span>
      </b-button>
      <!-- search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="handleSearch"
            />
          </div>
        </b-form-group>
      </div>

      <!-- table -->
      <vue-good-table
        mode="remote"
        :columns="columns"
        :rows="rows"
        :is-loading.sync="isLoading"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm }"
        :pagination-options="{
          enabled: true,
          perPage:pageLength
        }"
        @on-sort-change="onSortChange"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span v-if="props.column.field == 'price_currency_converted'">
            <span>{{ $staticParams.formatCurrency(props.row.price_currency_converted) }}</span>
          </span>
          <span v-else-if="props.column.field == 'count'">
            <span>{{ $staticParams.formatCurrency(props.row.count,0) }}</span>
          </span>
          <span v-else-if="props.column.field == 'hareket_tutar'">
            <span>{{ $staticParams.formatCurrency(props.row.hareket_tutar) }}</span>
          </span>
          <span
            v-else
          >
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
        <!-- pagination -->
        <template
          slot="pagination-bottom"
          slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                Showing 1 to
              </span>
              <b-form-select
                v-model="pageLength"
                :options="pages"
                class="mx-1"
                @input="handlePageChange"
              />
              <span class="text-nowrap"> of {{ totalRows }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="totalRows"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @change="handleChangePage"
                @input="(value)=>props.pageChanged({currentPage:value})"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BPagination, BFormGroup, BFormInput, BFormSelect, BButton,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BCardHeader,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    VueGoodTable,
    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
  },
  props: {

    userid: {
      type: Number,
      required: true,
    },
    targetYear: {
      type: Number,
      default: 0,
    },
    targetMonth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      isLoading: false,
      sort: 'desc',
      totalRows: 0,
      order_column: 'document_date',
      pages: ['10', '30', '50'],
      page: 1,
      columns: [
        {
          label: 'Tarih',
          field: 'document_date',
        },
        {
          label: 'Temsilci',
          field: 'representative_name',
        },
        {
          label: 'Müşteri',
          field: 'customer_name',
        },
        {
          label: 'Ürün',
          field: 'product_name',
        },
        {
          label: 'Birim Fiyatı',
          field: 'price_currency_converted',
        },
        {
          label: 'Adet',
          field: 'piece',
        },
        {
          label: 'Toplam Fiyat',
          field: 'hareket_tutar',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  computed: {

  },
  watch: {
    userid() {
      this.fetchData()
    },
    startdate() {
      this.fetchData()
    },
    enddate() {
      this.fetchData()
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    toExcel() {
      const excelUrl = `${process.env.VUE_APP_API_URL}/api/reports/user-sales-detail-report-excel?token=${useJwt.getToken()}&user_id=${this.userid}&ordering=${this.sort}&order_column=${this.order_column}&search_term=${this.searchTerm}&target_year=${this.targetYear}&target_month=${this.targetMonth}`
      window.location.href = `${excelUrl}`
    },
    fetchData() {
      store
        .dispatch('app-reports/fetchUserSalesDetail', {
          user_id: this.userid,
          ordering: this.sort,
          data_count: this.pageLength,
          search_term: this.searchTerm,
          order_column: this.order_column,
          target_year: this.targetYear,
          target_month: this.targetMonth,
          page: this.page,
        })
        .then(response => {
          const { data } = response.data.data
          const { meta } = response.data
          this.totalRows = meta.total
          this.rows = data
        })
        .catch(() => {
        })
    },
    // eslint-disable-next-line no-unused-vars
    handleSearch(searching) {
      this.fetchData()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchData()
    },
    // eslint-disable-next-line no-unused-vars
    handlePageChange(active) {
      this.fetchData()
    },
    onSortChange(params) {
      this.order_column = params[0].field
      this.sort = params[0].type
      this.fetchData()
    },
  },

}
</script>
